type Props = {
  message: string;
  onOk: () => void;
};

export function SubscriptionGateModal({ message, onOk }: Props) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="bg-white rounded-3xl p-8 max-w-sm w-full text-center">
        <p className="text-base font-bold text-slate-800 mb-6 leading-relaxed">{message}</p>
        <button
          type="button"
          onClick={onOk}
          className="w-full py-4 rounded-2xl bg-blue-600 text-white font-black"
        >
          OK
        </button>
      </div>
    </div>
  );
}
